module.exports = __webpack_public_path__ + "ff5e66a3b5cb8ea5134cb81be77eb831.woff";


//////////////////
// WEBPACK FOOTER
// ./css/fonts/ComicNeue/ComicNeue-Regular.woff
// module id = 381
// module chunks = 0